module.exports = __webpack_public_path__ + "img/medalha-super-combo.7465c48c.jpg";